<template>
  <pnet-validation-observer>
    <label>
      <small>{{label}}</small>
    </label>
    <div class="form-row" v-for="(stringValue, index) in stringList" v-bind:key="index">
      <div class="col-2" v-if="stringList[index].showLabel">
        <text-field
          v-model="stringList[index].valueLabel"
          :readonly="stringList[index].valueLabelReadonly"
          v-if="!stringList[index].valueLabelFix"
        ></text-field>
        <div v-if="stringList[index].valueLabelFix">
          <div>
            {{stringList[index].valueLabel}}
          </div>
        </div>
      </div>
      <div class="col-1" v-if="stringList[index].showSign && stringList[index].valueSignLeft">
        <text-field
          v-model="stringList[index].valueSign"
          :readonly="stringList[index].valueSignReadonly"
        ></text-field>
      </div>
      <div class="col-6">
        <text-field v-model="stringList[index].value"></text-field>
      </div>
      <div class="col-1" v-if="stringList[index].showSign && !stringList[index].valueSignLeft">
        <text-field
          v-model="stringList[index].valueSign"
          :readonly="stringList[index].valueSignReadonly"
        ></text-field>
      </div>
    </div>
    <div class="" v-if="!disableAdd">
      <div class="filtri mb-4">
        <div class="col-12 col-md-4 col-lg-12" align="left">
          Aggiungi&nbsp;&nbsp;<b-button class="btn btn-primary p-1 pl-3 pr-3" v-on:click.prevent="inserisci">+</b-button>
          <b-button
            v-if="stringList.length > 1"
            class="btn btn-primary p-1 pl-3 pr-3"
            v-on:click.prevent="cancella"
          >-</b-button>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
export default Vue.extend({
  props: ["value","label","showSign","signValue","signReadonly","signOnLeft","showLabel","labelValue","labelReadonly","labelFix","disableAdd"],
  components: {
    TextField,
  },
  data: function() {
    return {
      stringList: [
        {
          value: "",
          showSign: false,
          valueSign: "",
          valueSignReadonly: false,
          valueSignLeft: false,
          showLabel:false,
          valueLabel: "",
          valueLabelReadonly: false,
          valueLabelFix: false
        }
      ],
    }
  },
  methods: {
    inserisci: function() {
      this.stringList.push(
        {
          value: "",
          showSign: this.showSign,
          valueSign: "",
          valueSignReadonly: this.signReadonly,
          valueSignLeft: this.signOnLeft,
          showLabel: this.showLabel,
          valueLabel: "",
          valueLabelReadonly: this.labelReadonly,
          valueLabelFix: this.labelFix,
        }
      );
    },
    cancella: function() {
      this.stringList.pop();
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(){
        if (this.value === undefined) {
          this.stringList = [
            {
              value: "",
              showSign: this.showSign,
              valueSign: "",
              valueSignReadonly: this.signReadonly,
              valueSignLeft: this.signOnLeft,
              showLabel: this.showLabel,
              valueLabel: "",
              valueLabelReadonly: this.labelReadonly,
              valueLabelFix: this.labelFix,
            }
          ];
        } else {
          this.stringList = this.value;
        }
        if (this.signValue !== undefined) {
          for (var i in this.value) {
            if (this.value[i].valueSign === undefined) {
              this.value[i].valueSign = this.signValue;
            }
          }
        }        
        if (this.labelValue !== undefined) {
          let counter = 1;
          for (var i in this.value) {
            this.value[i].valueLabel = this.labelValue.replace(/<index>/g, counter);
            counter++;
          }
        }        
      }
    },
    stringList: {
      deep: true,
      immediate: true,
      handler(){
        this.$emit('input', this.stringList);
      }
    },
  },
  mounted() {
    this.stringList = this.value;
  },
});
</script>